import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@core/utils/cn";

// eslint-disable-next-line react-refresh/only-export-components
export const spinnerStyles = cva("animate-spin", {
  variants: {
    variant: {
      solid: "text-neutral-100",
      secondary: "text-primary-950",
      ghost: "text-secondary-300",
      text: "text-primary-950",
      link: "text-primary-950",
      destructive: "text-white",
      warning: "text-white",
      success: "text-white",
    },
    size: {
      sm: "size-4",
      md: "size-5",
      lg: "size-6",
    },
  },
  defaultVariants: {
    variant: "solid",
    size: "md",
  },
});

type SpinnerProps = VariantProps<typeof spinnerStyles> & {
  className?: string;
};

export function Spinner({ variant, size, className }: SpinnerProps) {
  const r = 44;
  const circumference = 2 * Math.PI * r;
  const arcLength = circumference * 0.25;

  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      aria-label="Loading"
      className={cn(spinnerStyles({ variant, size }), className)}
    >
      <circle
        cx="50"
        cy="50"
        r={r}
        stroke="currentColor"
        strokeWidth="12"
        strokeLinecap="round"
        strokeDasharray={`${arcLength} ${circumference - arcLength}`}
        strokeDashoffset={circumference * 0.25}
      />
    </svg>
  );
}
